import { IConvertOption } from '@/types/currency-formatter.type'

const U_PK = 1e3
const U_PM = 1e6
const U_HM = 1e8 // 1억
const U_PB = 1e9
const U_PT = 1e12 // 1조
const U_PQ = 1e15
const U_TQ = 1e16 // 1경
const U_PX = 1e18

class DecimalConverter {
  private number: number
  private decimalPoint: number
  private showZero: boolean
  private showDecimalZero: boolean
  private unit?: string
  private contraction?: boolean

  constructor(param: IConvertOption) {
    this.number = isNaN(Number(param.number)) ? 0 : Number(param.number)
    this.decimalPoint = param.decimalPoint === '' ? 0 : isNaN(Number(param.decimalPoint)) ? 0 : Number(param.decimalPoint)
    this.showZero = param.showZero ?? true
    this.showDecimalZero = param.showDecimalZero ?? true
    this.unit = param.unit
    this.contraction = param.contraction ?? true
  }

  convert() {
    const number = this.number
    if (number === 0) {
      if (this.showZero) return '0'
      return '-'
    }
    return this.convertToContraction(number)
  }

  convertToContraction(inputNumber: number) {
    if (Math.abs(inputNumber) < U_PK || this.unit === '%' || this.unit === 'percent' || !this.contraction){
      return this._fixUnits(inputNumber)
    } else if (Math.abs(inputNumber) < U_PM) {
      return this._fixUnits(inputNumber, U_PK) + 'K'
    } else if (Math.abs(inputNumber) < U_PB) {
      return this._fixUnits(inputNumber, U_PM) + 'M'
    } else if (Math.abs(inputNumber) < U_PT) {
      return this._fixUnits(inputNumber, U_PB) + 'B'
    } else if (Math.abs(inputNumber) < U_PQ) {
      return this._fixUnits(inputNumber, U_PT) + 'T'
    }
    return this._fixUnits(inputNumber, U_PQ) + 'Q'
  }

  _fixUnits(inputNumber: number, divider?: number) {
    let result = ''
    try {
      const dividedNumber = divider
        ? this._divideByAbs(inputNumber, divider)
        : inputNumber
      if (this.decimalPoint === 0) {
        return this._noFixUnits(dividedNumber)
      } else {
        // 소수점 버림을 위한 처리
        const tempNum =
          dividedNumber > 0
            ? Math.floor(dividedNumber * 10 ** this.decimalPoint) /
              10 ** this.decimalPoint
            : Math.ceil(dividedNumber * 10 ** this.decimalPoint) /
              10 ** this.decimalPoint
        const [ beforeDot, afterDot ] = String(tempNum).split('.')
        result = beforeDot.replace(/\B(?=(\d{3})+(?!\d))/g, ',')

        // 소수점 이하가 0인경우 주어진 옵션을 통해 display 여부를 결정한다.
        if (this.showDecimalZero) {
          result += afterDot ? `.${afterDot}` : this._replacedUnit()
        } else {
          result +=
            Number(afterDot) === 0 || isNaN(Number(afterDot))
              ? ''
              : `.${afterDot}`
        }
      }
    } catch {
      result = '-1'
    }
    return result
  }

  _replacedUnit() {
    let unit = '.'
    for (let i = 0; i < this.decimalPoint; i++) {
      unit += '0'
    }
    return unit
  }

  _noFixUnits(inputNumber: number) {
    let result = ''
    try {
      const n = inputNumber.toFixed(0)
      result = n.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    } catch {
      result = '-1'
      console.warn('somthing is wrong', inputNumber)
    }
    return result
  }

  _divideByAbs(inputNumber: number, divider: number) {
    let result = Math.abs(inputNumber) / divider
    if (inputNumber < 0) result *= -1
    return result
  }
}

export function currencyFormatter(param: IConvertOption) {
  const cvt = new DecimalConverter(param)

  let result = cvt.convert()
  if (param.unit) {
    if (param.unit === 'KRW' || param.unit === '₩') result = '₩' + result
    else if (param.unit === 'USD' || param.unit === '$')
      result =
        result.indexOf('-') > -1
          ? '-$' + result.replaceAll('-', '')
          : '$' + result
    else if (param.unit === 'percent') result += '%'
    else result += ` ${param.unit}`
  }
  return result
}
